import { Layers3 } from "lucide-react";

export function FlashcardIndicator(): React.JSX.Element {
  return (
    <span className="flashcard-indicator" aria-label="Has flashcards">
      <Layers3 size={13} aria-hidden="true" />
    </span>
  );
}
